import { IdService } from "./../shared/services/id.service";
import {
	Component,
	OnDestroy,
	Input,
	Output,
	EventEmitter
} from "@angular/core";
import { trigger, state, style, transition, animate } from "@angular/animations";

@Component({
	selector: "rbc-alert",
	template: `
		<!-- If transition -->
		<ng-container *ngIf="transition; else isNotTransition">
				<div [@opacity-height]="{value:visible}"
					[id]="id"
					class="rbc-alert"
					role="alert"
					[ngClass]="classGen()">

					<rbc-icon
						[id]="id+'Icon'"
						[icon]="iconGen()"
						[attr.aria-hidden]="true"
						type="solid"
						class="rbc-alert-icon"
					></rbc-icon>
					<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
				</div>
		</ng-container>

		<!-- If not transition -->
		<ng-template #isNotTransition>
			<div
				[id]="id"
				*ngIf="visible"
				class="rbc-alert"
				role="alert"
				[ngClass]="'rbc-alert-' + type"
			>
				<ng-container *ngTemplateOutlet="bodyTmp"></ng-container>
			</div>
		</ng-template>

		<!-- Alert Body -->
		<ng-template #bodyTmp>
			<div class="rbc-alert-body">
				<h4 *ngIf="title" [id]="id + 'Title'" class="rbc-alert-title">
					{{ title }}
				</h4>
				<ng-content></ng-content>
				<button
					*ngIf="closable"
					[id]="id+'CloseButton'"
					[attr.aria-label]="closeLabel"
					class="rbc-alert-close-button"
					(click)="alertClose()"
				>
					<rbc-icon
						[attr.aria-hidden]="true"
						type="solid"
						icon="times"
					></rbc-icon>
				</button>
			</div>
		</ng-template>
	`,
	animations: [
		trigger("opacity-height", [
			state("true", style({
				overflow: "hidden",
				height: "*",
				opacity: 1
			})),
			state("false", style({
				height: "0px",
				overflow: "hidden",
				opacity: 0
			})),
			state("void", style({
				height: "*",
				overflow: "hidden",
			})),
			transition("true => false", animate("400ms ease-out")),
			transition("false => true", animate("400ms ease-in"))
		]),
	],
})
export class AlertComponent implements OnDestroy {
	@Input() closable = true;
	@Input() title: string;
	@Input() id: string;
	@Input() transition = true;
	@Input() type: "danger" | "warning" | "success" | "info" = "info";
	@Input() closeLabel = "Close";
	@Input() shadow: boolean = true;

	@Output() alertClosed = new EventEmitter();

	msg = "default";
	visible = true;

	constructor(private idService: IdService) {
		this.id = idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}

	alertClose() {
		this.visible = false;
		// allow parent to know if the close button has been pressed
		this.alertClosed.emit("alert closed");
	}

	iconGen() {
		const icons = {
			danger: "exclamation-square",
			success: "check-circle",
			warning: "exclamation-triangle",
			info: "info-circle"
		};

		// return this.icon || icons[this.type];
		return icons[this.type];
	}

	classGen(){
		let classes = {};
		classes["rbc-alert-"+ this.type] = this.type;
		classes["rbc-alert-shadow"] = this.shadow;
		return classes;
	}
}
